import React from 'react';
import { PageHero } from '../components/PageHero';
import { Reveal } from '../components/Reveal';
import { CtaBand } from '../components/CtaBand';
import { industries } from '../data/industries';
export function Industries() {
  return <>
      <PageHero breadcrumb="Industries" title="Sector depth, cross-industry perspective." lead="We know the leaders who define each market — and the ones from adjacent sectors who can bring a fresh perspective to it." data-id="element-364" data-mp="2h84xktr8v1ij" />
      <section className="bg-ivory" data-id="element-365" data-mp="22ktjol7lb5f9">
        <div className="mx-auto max-w-site px-6 py-20 lg:px-10 lg:py-28" data-id="element-366" data-mp="22jidkeqo9lkz">
          <ul className="grid gap-x-16 md:grid-cols-2" data-id="element-367" data-mp="1xn0d3r2dk9eg">
            {industries.map((industry, i) => <li key={industry.id} id={industry.id} className="scroll-mt-36 border-t border-midnight-900/15" data-id="element-368" data-mp="1tlol5ew13c33" data-mpi={i}>
                <Reveal delay={i % 2 * 0.05} className="flex h-full flex-col py-10" data-id="element-369" data-mp="1okr6hca8906c">
                  <h2 className="font-serif text-3xl text-midnight-900" data-id="element-370" data-mp="1jnijmye4w7yr">{industry.name}</h2>
                  <p className="mt-4 text-[16px] leading-relaxed text-midnight-900/70" data-id="element-371" data-mp="1qmhkkdj39uob">{industry.summary}</p>
                  <p className="mt-auto pt-6 text-sm text-midnight-900/55" data-id="element-372" data-mp="1vf2d7bq9e1q9">
                    <span className="font-medium text-midnight-900/80" data-id="element-373" data-mp="1hnniw8qwie3w">Typical mandates: </span>
                    {industry.roles.join(' · ')}
                  </p>
                </Reveal>
              </li>)}
          </ul>
        </div>
      </section>
      <CtaBand data-id="element-374" data-mp="2ed4wd9w4l4g5" />
    </>;
}